<script>
import Behaviour from './Behaviours';
import { AjaxCaller } from '@ssdcode/cms-partials';
import ErrorReporter from '../../core/ErrorReporter';
export default {
  name: 'ClickAction',
  mixins: [AjaxCaller],
  props: {
    behaviour: {
      type: String,
      default: 'redirect',
    },
    initialData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    payload: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      response: this.initialData,
    };
  },
  computed: {
    requestData() {
      return this.payload;
    },
  },
  methods: {
    confirm(id, message) {
      const handler = response => {
        this.success((this.response = response.response));
      };
      window.EventBus.unlisten(id + '-called', handler);
      window.EventBus.listen(id + '-called', handler);
      window.EventBus.fire('top-confirm', {
        id: id,
        message: message,
        url: this.action,
        method: this.method,
      });
    },
    call() {
      this.makeAjaxCall(this.success, this.failure);
    },
    success(response) {
      new Behaviour(this, this.behaviour, response);
    },
    failure(error) {
      if ([301, 302].includes(error.response.status)) {
        new Behaviour(this, 'redirect', error.response);
        return;
      }
      this.stopProcessingAjaxCall();
      ErrorReporter.report(error);
    },
  },
  render() {
    return this.$scopedSlots.default({
      call: this.call,
      confirm: this.confirm,
      processing: this.processing,
      response: this.response,
    });
  },
};
</script>
